let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("frhR0")).then(() => parcelRequire('5O8EX'));